<ul class="nav nav-tabs">
  <li role="presentation">
    @if (('workload.timetable'|HasPerm)) {
      <a uiSref="a.workload.timetable" target="_blank">
        Auslastungskalender öffnen
      </a>
    }
  </li>
</ul>
